// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__W9PF+","header":"layout_header__tuP2-","info":"layout_info__tuJ56"};